
import { Component } from 'vue-property-decorator';
import { appModule, userModule } from './store';

import Logo from '@/components/UI/Logo.vue';
import LoaderUI from '@/components/UI/Loader.vue'
import ModalUI from '@/components/UI/Modal.vue'
import TextUI from '@/components/UI/Text.vue'
import CopyrightVue from '@/components/Copyright.vue'
import { socketClient } from './modules/SocketClient';
import { mixins } from 'vue-class-component';
import SocketMixin from './components/mixins/SocketMixin';

import { AppService } from '@/services/AppService'
import { SoloRiddleService } from '@/services/SoloRiddleService'

@Component({
  components: {
    Logo,
    LoaderUI,
    ModalUI,
    TextUI,
    CopyrightVue
  }
})
export default class App extends mixins(SocketMixin) {
  // Local UI and cached routes are usable immediately. Version information
  // and the offline riddle snapshot refresh in the background.
  loaded = true
  cacheWidth = 0
  cacheHeight = 0

  hasError = false
  stopConnectionListener: (() => void) | null = null

  showExitModal(e: Event) {
    if(this.$route.name === 'game') {
      this.$root.$emit('game:exitModal')
      e.preventDefault()
    }
    else if (this.$route.name === 'solo-game') {
      this.$root.$emit('solo:exitModal')
      e.preventDefault()
    }
    else if (this.$route.name === 'room') {
      this.$root.$emit('room:exitModal')
      e.preventDefault()
    }
  }

  get isConnect() {
    return socketClient.connected
  }

  get showConnectionError() {
    return this.hasError && ['rooms', 'room', 'game'].includes(this.$route.name || '')
  }

  get roomNotFoundVisible() {
    return this.$route.query.roomNotFound === '1'
  }

  async closeRoomNotFound() {
    await this.$router.replace({ name: 'index' })
  }

  get gameCrashed() {
    return appModule.gameCrashed
  }

  get languageLocked() {
    return this.$route.name === 'solo-game'
  }

  switchLang() {
    const locale = this.$i18n.locale === 'ru' ? 'en' : 'ru'
    userModule.updateLang(locale)
    this.$i18n.locale = locale
  }

  created() {
    const appService = new AppService
    userModule.loadUser()

    void appService.getUpdateInfo().then(res => {
      if (res) appModule.updateInfo(res.data)
    })
    void new SoloRiddleService().preload()
    window.addEventListener('online', () => void new SoloRiddleService().preload())

    const name = window.localStorage.getItem("user_name")
    if(name) {
      userModule.setName(name)
    }
    const lang = window.localStorage.getItem('lang')
    if (lang) {
      userModule.updateLang(lang)
      this.$i18n.locale = lang
    }

    this.cacheWidth = window.innerWidth
    this.cacheHeight = window.innerHeight

    window.addEventListener("resize", () => {
      if(window.innerHeight === this.cacheHeight) return

      this.cacheHeight = window.innerHeight
    })

    this.initSocket()
    this.stopConnectionListener = socketClient.onConnectionChange(connected => {
      this.hasError = !connected
    })

    this.$root.$on('game:crashed', () => {
      const clickListener = () => {
        appModule.updateGameCrashed(false)
        document.removeEventListener('click', clickListener)
      }
      appModule.updateGameCrashed(true)
      document.addEventListener('click', clickListener)
    })
  }

  beforeDestroy() {
    this.stopConnectionListener?.()
  }
}
